/**
 * patrol-tracking-view.js
 */

import React from 'react';
import { parseISO, format } from 'date-fns';
import { Types } from 'utils/constants';
import { displayNumber } from 'utils/misc';
import IconSection from 'components/icon-section';
import InfoRow from 'components/info-row';
import { ExerciseFollowMap } from 'components/tracking/map/viewing-map';
import { PatrolTypeTitle } from '../../training-utils';


export default function PatrolTrackingView(props) {
  const { record, patrolTypes } = props;
  const tracking = record.tracking;
  const [isFirstTrackingType] = React.useState(
    patrolTypes.find(pt => pt.type === Types.Patrol.TRACKING).order === record.order
  );


  return (
    <>
      {record &&
      <IconSection iconName='patrol-tracking'>

        <PatrolTypeTitle 
          patrolType={record.type} 
          patrolTypes={patrolTypes} 
          step={record.order}
        />
        
        <InfoRow title='Track Location Known' text={tracking.isKnownLocation ? 'Yes' : 'No'} />
        <InfoRow title='Controlled Negative' text={tracking.isControlledNegative ? 'Yes' : 'No'} />
        {tracking.items?.filter(i => i.id && i.name).length > 0 && <InfoRow title='Search Items' text={tracking.items.map(i => i.name).join(', ')} />}
        <InfoRow title='Track Name' text={tracking.trackLayerName} />
        {tracking.trackDistance != null && <InfoRow title='Track Distance' text={`${displayNumber(tracking.trackDistance)} ${tracking.trackDistanceUnit.name}`} />}
        {tracking.trackTotalTurns !== null && <InfoRow title='Track Turns' text={tracking.trackTotalTurns} />}
        {tracking.trackLaidTime && <InfoRow title='Track Laid Time' text={format(parseISO(tracking.trackLaidTime), 'h:mm aaa')} />}
        {tracking.trackFollowedTime && <InfoRow title='Track Followed Time' text={format(parseISO(tracking.trackFollowedTime), 'h:mm aaa')} />}
        <InfoRow title='Track Duration' text={`${tracking.trackDuration} minute${tracking.trackDuration === 1 ? '' : 's'}`} />
        {tracking.trackTotalHumansCrossing !== null && <InfoRow title='Number of Human Crossings' text={tracking.trackTotalHumansCrossing} />}
        <InfoRow title='Terrain Types' text={tracking.terrainTypes.map(type => type.customOtherName || type.name).join(', ')} />
        {tracking.contaminantTypes.length > 0 && 
        <InfoRow 
          title='Contaminant Types' 
          text={tracking.contaminantTypes.map(type => type.customOtherName || type.name).join(', ')} 
        />}

      </IconSection>}      

      {isFirstTrackingType &&
      <ExerciseFollowMap
        recordId={props.answerId}
        trackingRecord={tracking}
      />}
    </>
  );
}